/* eslint-disable max-classes-per-file */
import { Expose, Type } from 'class-transformer'
import { BookCollectionPrivacyEnum } from '@interfaces/BookCollectionPrivacyEnum'
import { BookListType } from './BookListType'

class UserType {
  id: number

  avatarImgPath: string

  username: string

  displayName: string

  profilePageSlug: string
}

export class BookCollectionDetailResponse {
  @Expose()
  id: number

  @Expose()
  collectionName: string

  @Expose()
  description: string

  @Expose()
  privacyType: BookCollectionPrivacyEnum

  @Expose()
  @Type(() => UserType)
  user: UserType

  @Expose()
  likeCount: number

  @Expose()
  isLiked: boolean

  @Expose()
  facebookShareImageUrl: string

  @Expose()
  twitterShareImageUrl: string

  @Expose()
  @Type(() => BookListType)
  bookList: BookListType
}
